import "./Cse_projecthon.css";
import "./Csedept.css";
import { Backtotop, Floatinmenu, Underline, ContentCard } from "../../widgets";
import { RadialMenu } from "../../components";
import { Table } from "../../components";
import { FaComputer } from "react-icons/fa6";
import { cse_dept_menu, cse_projecthon } from "../../constants/cse_dept";
import Gallery from "../../components/Gallery/Gallery";

const cse_asso_logo =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/codequest-images/CSE_ASSO_LOGO.webp";

/*const projecthon_gallery_1 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon1.webp";*/
const projecthon_gallery_2 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon2.webp";
/*const projecthon_gallery_3 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon3.webp";*/
const projecthon_gallery_4 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon4.webp";
/*const projecthon_gallery_5 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon5.webp";*/

const projecthon_gallery_6 =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon6.webp";
const projecthon_gallery_7 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon7.webp";
const projecthon_gallery_8 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon8.webp";
const projecthon_about ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cse/projecthon/projecthon1+(1).webp";


export default function Cse_projecthon() {
  const projecthonImages = [
  
    projecthon_gallery_2,
    projecthon_gallery_4,
    projecthon_gallery_6,
    projecthon_gallery_7,
    projecthon_gallery_8,
    projecthon_about

  ];


  return (
    <>
      <div className="csedept">
        <div className="csebg">
          <div className="cseheading">
            Department of Computer Science and Engineering
          </div>
          <div className="cse_sub_heading">Projecthon</div>
        </div>

        <section className="csedark">
          <div className="dept_float_menu">
            <Floatinmenu logo={FaComputer} head="Menu" links={cse_dept_menu} />
          </div>

          <RadialMenu menu_links={cse_dept_menu} />

          <div className="cse_lab_area">
            <Underline heading="About the Projecthon" />

            <div className="csetwo-col">
              <p className="cse_dept_content">
                Projecthon is a platform where students demonstrate projects based on a given project description.
                Started in <strong>2025,</strong> it provides an opportunity to convert ideas into working solutions within a defined scope and structured timeline.
                Participants understand real-world problem statements and implement them practically.
                The platform is guided and mentored by final-year students, encouraging peer learning and collaboration.
                Projecthon fosters innovation, creativity, and hands-on learning throughout the development process.
                It helps improve technical, problem-solving, and presentation skills. The initiative also promotes teamwork and effective time management.
                Overall, Projecthon bridges the gap between theoretical knowledge and practical implementation.
              </p>
              <div className="dept_img_holder">
                <img
                  className="projecthon_img"
                  src={projecthon_about}
                  alt="Projecthon"
                />
              </div>


            </div>
            
            <Underline heading="Organized by CSE Association" />
            <div className="projecthon-organizer">
              <div className="projecthon-logo">
                <img src={cse_asso_logo} alt="CSE Association Logo" />
              </div>
              <div className="projecthon-description">
                <p>
                  Projecthon is proudly conducted by the 
                  <strong>  CSE Association</strong> of ACGCET. The association is
                  committed to cultivating technical excellence, collaborative
                  learning, and innovation among students. This competition is
                  one of its key initiatives to empower aspiring developers and
                  encourage a culture of  solving real-world problems.
                </p>
              </div>
            </div>
            <Underline heading="Gallery Highlights" />
            <div className="projecthon_gallery">
              <Gallery images={projecthonImages} title="Projecthon Moments" />
            </div>
            <Underline heading="Projecthon Participation " />
            <div className="projecthon_team">
              {cse_projecthon.map((item) => (
                <ContentCard
                  key={item.id}
                  heading={item.program}
                  pdf={item.pdf}
                />
              ))}
            </div>
          </div>
        </section>

        <Backtotop />
      </div>
    </>
  );
}
